import * as angular from "angular";
import {IController, IFilterService} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../services/agent-dialogs-service.service";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentModel} from "../../angular/models/agent.model";
import {AgentsService} from "../../services/agents-service.service";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {DevicesRequestsService} from "../../../devices/services/devices-requests.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import {GpsPermissionType} from "../../types/gps-permission.type";
import {AgentStatusType} from "../../types/agentStatus.type";

export class AgentItineraryPanelCtrl implements IController {

  selectedAgent: AgentModel;
  agentConfigurationProfile: any;
  attachedLogisticsVehicles: LogisticsVehicle[];
  itinerary: any;
  tasks: any;
  totals: any;
  selectedTab: any;
  isEdit: any;
  editModeExternalChange: any;
  showAgentInfo: any;
  highlightedServiceId: any;
  inActiveTasksDate: any;
  isExpandedTasks: any;
  completedRouteTasksData: number;

  onInactiveDateChange: Function;
  onHighlightedChanged: Function;
  onTabSelect: Function;
  onToggleEdit: Function;
  onBack: Function;
  onSaveEditMode: Function;
  onEditItineraryOrderChange: Function;
  onUpdateItinerary: Function;
  onReset: Function;
  onToggleMap: Function;
  onBindVehicle: Function;
  onUnbindVehicle: Function;
  onToggleTasksExpanded: Function;
  onToggleAssistantItinerary: Function;
  onAskToEnableGps: Function;
  onAskToEnableGpsPermissions: Function;
  onAskToClockIn: Function;

  public agent: AgentModel;
  private tasksRef: any;
  public lastTask: any;
  public device: any;
  public showRouteInfo: any;
  public configZoneId: string;

  public userNameId: any;
  private taskIdListType: any;
  private modifyItineraryChanged: any;
  private savingItineary: any;
  private completedTasksTimeRef: any;
  private editModeTaskIdList: any;
  public filterAgentsByGpsEnabled: boolean;
  public hasLogisticVehicleUpdatePermission: boolean;
  public isExpendedTable: boolean;
  public gpsPermissionType: typeof GpsPermissionType = GpsPermissionType;
  public agentStatusType: typeof AgentStatusType = AgentStatusType;
  public showLastAgentEditAt: boolean = false;


  constructor(private devicesRequestsService: DevicesRequestsService, private $log, private UserService, private $filter: IFilterService, private $task,
              private agentRequests: AgentRequests, private agentDialogService: AgentDialogService, private IAMPermissions, private moment,
              private splitService: SplitService, private agentsService: AgentsService, private siteContextService: SiteContextService,
              private analyticsService: AnalyticsService) {
    this.tasksRef = this.$task();
  }

  $onInit() {

    this.isExpendedTable = !!this.showAgentInfo;

    if (this.selectedAgent) {
      this.agent = angular.copy(this.selectedAgent);
    }
    this.hasLogisticVehicleUpdatePermission = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.update') &&
      !!this.splitService.getEnableAgentVehicleBinding();


    this.configZoneId = this.splitService.getTimeZone();
    this.userNameId = this.UserService.getCurrentUser().id; // Current admin user id.
    this.taskIdListType = 'taskIdsExt';
    this.modifyItineraryChanged = false; // Modifying Edit Itinerary when tasks changes occur.
    this.savingItineary = false; // When true, modifying edit mode is disabled.
    this.showRouteInfo = false;
    this.completedTasksTimeRef = null;
    this.editModeTaskIdList = [];
    this.device = undefined;

    this.filterAgentsByGpsEnabled = this.siteContextService.getSiteInfo().filterAgentsByGpsEnabled;

    // ctrl.analysisMap = undefined;
    const selectedAgentIdRef = angular.copy(this.agent.id);

    // ctrl.initCompletedTasksTab();
    // ctrl.getAnalysis(selectedAgentIdRef);
    this._getDeviceData(selectedAgentIdRef);
  }

  $onChanges(changes) {
    if (changes.selectedAgent && !changes.selectedAgent.isFirstChange()) {
      this.agent = angular.copy(this.selectedAgent);

      let currentAgentId = _.get(changes.selectedAgent, 'currentValue.id'),
        previousAgentId = _.get(changes.selectedAgent, 'previousValue.id');

      if (currentAgentId && !_.isEqual(currentAgentId, previousAgentId)) {
        this._getDeviceData(currentAgentId);
      }
    }
    if (changes.tasks && !changes.tasks.isFirstChange()) {
      if (this.tasks?.length) {
        let lastTaskId = _.last(this.itinerary.taskIdList);
        this.lastTask = this.tasks.find(t => t.id === lastTaskId);
      } else {
        this.lastTask = undefined;
      }
    }

    if (changes.itinerary) {
      this.showLastAgentEditAt = this.itinerary?.lastAgentEditAt ?
        this.moment(this.moment(this.itinerary.lastAgentEditAt).format("MM/DD/YYYY")).isSame(this.moment().format("MM/DD/YYYY")) :
        false;
    }
  }

  $onDestroy() {
    if (_.isEqual(_.get(this.agent, 'itineraryInfo.itineraryEditLockedByAdmin'), this.userNameId)) {
      this.agentRequests.editItineraryUnlock(_.get(this.itinerary, 'agent.id'));
    }
  };

  onSettings() {
    this.agentDialogService.itinerarySettings(this.itinerary)
      .then((updatedItinerary) => {
        this.onUpdateItinerary({itinerary: updatedItinerary})
      })
      .catch((error) => {
        if (error) {
          this.$log.error(error.message);
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }

  onExpandTable() {
    this.isExpendedTable = !this.isExpendedTable;
  }

  sendSMS($event) {
    this.analyticsService.trackEvent('Agents Actions', 'Send SMS', 'Click');
    this.agentDialogService.sendSMS($event, this.agent)
      .then(() => {

      })
      .catch((error) => {
        if (error) {
          this.analyticsService.trackEvent('Agents Actions', 'Send SMS', 'Error');
          this.$log.error(error.message);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  private _getDeviceData(agentId) {
    let deviceAgentIdRef = agentId;
    this.device = undefined;

    let deviceId: string;
    if (!this.agent.lastKnownLocation?.deviceReference?.id) {
      return;
    }

    deviceId = this.agent.lastKnownLocation.deviceReference.id;

    this.devicesRequestsService.getDevices(agentId)
      .then((devices) => {
        if (deviceAgentIdRef === this.agent.id) {
          this.device = devices.find(d => d.id === deviceId);

          if (this.device.updatedAt) {
            this.agent.lastKnownLocation.updatedAt = this.device.updatedAt;
          }
        }
      })
      .catch((error) => {
        this.$log.error('Failed to get devices by agent @agentItinerary@$onInit', error);
      });
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryPanel', {
    bindings: {
      selectedAgent: '<',
      attachedLogisticsVehicles: '<?',
      agentConfigurationProfile: '<',
      itinerary: '<',
      tasks: '<',
      totals: '<',
      selectedTab: '<',
      isEdit: '<',
      editModeExternalChange: '<',
      showAgentInfo: '<?',
      highlightedServiceId: '<?',
      inActiveTasksDate: '<',
      isExpandedTasks: '<?',
      completedRouteTasksData: '<?',
      onInactiveDateChange: '&',
      onHighlightedChanged: '&',
      onTabSelect: '&',
      onToggleEdit: '&',
      onBack: '&',
      onSaveEditMode: '&',
      onEditItineraryOrderChange: '&',
      onUpdateItinerary: '&',
      onReset: '&',
      onToggleMap: '&',
      onToggleTasksExpanded: '&',
      onBindVehicle: '&',
      onUnbindVehicle: '&',
      onAskToEnableGps: '&',
      onAskToEnableGpsPermissions: '&',
      onToggleAssistantItinerary: '&',
      onAskToClockIn: '&'
    },
    template: require('./agent-itinerary-panel.html').default,
    controller: AgentItineraryPanelCtrl
  });
